import { useEffect, useState } from "react";

function App() {
  const [pass, setPass] = useState("");
  const [hasCap, setHasCap] = useState(false);
  const [hasLower, setHasLower] = useState(false);
  const [hasNum, setHasNum] = useState(false);
  const [hasChar, setHasChar] = useState(false);
  const [isEightLength, setIsEightLength] = useState(false);

  const [type, setType] = useState("text");
  const [icon, setIcon] = useState("✖");

  const caps = [...Array(26)].map((_, i) => String.fromCharCode(i + 65));
  const lowers = caps.map((cap) => cap.toLowerCase());
  const nums = Array.from(Array(10).keys());
  const chars = "[`!@#$%^&*()_+-=[]{};':\"\\|,.<>/?~]/";

  useEffect(() => {
    setHasCap(caps.some((cap) => pass.includes(cap)));

    setHasLower(lowers.some((lower) => pass.includes(lower)));

    setHasNum(nums.some((num) => pass.includes(num)));

    setHasChar(chars.split("").some((char) => pass.includes(char)));

    setIsEightLength(pass.length >= 8);
  }, [pass, caps, lowers, nums, chars]);

  function handleToggle(e) {
    e.preventDefault();

    if (type === "text") {
      setIcon("👁");
      setType("password");
    } else {
      setIcon("✖");
      setType("text");
    }
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-blue-400">
      <form className="bg-white rounded-3xl p-8 text-gray-500">
        <h1 className="text-lg">Password</h1>
        <div className="relative">
          <input
            className="border-b-2 border-b-gray-400 outline-none text-black my-4 w-full px-1 focus:border-b-gray-600 transition-colors"
            type={type}
            value={pass}
            onChange={(e) => setPass(e.target.value)}
          />
          <button
            className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 text-lg"
            onClick={handleToggle}
          >
            {icon}
          </button>
        </div>
        <div className="flex flex-col gap-4">
          <p className={`${hasLower && hasCap ? "text-green-500" : ""}`}>
            <Check className={hasLower && hasCap ? "visible" : "invisible"} />
            Lowercase & Uppercase
          </p>
          <p className={`${hasNum ? "text-green-500" : ""}`}>
            <Check className={hasNum ? "visible" : "invisible"} />
            Number (9-0)
          </p>
          <p className={`${hasChar ? "text-green-500" : ""}`}>
            <Check className={hasChar ? "visible" : "invisible"} />
            Special Character (!@#$%^&*)
          </p>
          <p className={`${isEightLength ? "text-green-500" : ""}`}>
            <Check className={isEightLength ? "visible" : "invisible"} />
            Atleast 8 Character
          </p>
        </div>
      </form>
    </div>
  );
}

function Check({ className }) {
  return <span className={`mr-1 ${className}`}>✔</span>;
}

export default App;
